import { render, staticRenderFns } from "./dividedIntoInformations.vue?vue&type=template&id=32afdda3&scoped=true"
import script from "./dividedIntoInformations.vue?vue&type=script&lang=js"
export * from "./dividedIntoInformations.vue?vue&type=script&lang=js"
import style0 from "./dividedIntoInformations.vue?vue&type=style&index=0&id=32afdda3&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32afdda3",
  null
  
)

export default component.exports